import { TableFilterType } from 'features/TableFilter';

interface ZoneBoxesListFilters {
  floorId?: string;
}

export const transformZoneBoxesListFilters = (filters: TableFilterType): ZoneBoxesListFilters => {
  return {
    floorId: filters.floorId?.value || undefined,
  };
};
